import { PayloadAction } from '@reduxjs/toolkit';
import { call, put, select, takeEvery } from 'typed-redux-saga';

import GoldGateway from '~apis/gold';
import combinedActions from '~redux/combinedActions';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';
import { ErrorMessages } from '~utils/constants';

export default function* watchGetBranchMarketStatus(api: GoldGateway): SagaWatcherReturnType {
    yield takeEvery('gold/goldGetBranchMarketStatusAttempt', handleGetBranchMarketStatus, api);
}

function* handleGetBranchMarketStatus(api: GoldGateway, action: PayloadAction<{branchCode: string}>) {
    const authToken = yield* select((state) => state.auth.userDetails.authToken);

    const branchCode = action.payload.branchCode;

    const response = yield* call([api, api.getBranchMarketStatus], {
        authToken,
        branchCode,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(
            combinedActions.goldGetBranchMarketStatusFailure(
                response.message || ErrorMessages.GenericError
            )
        );
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(
            combinedActions.goldGetBranchMarketStatusSuccess(response.data)
        );
    }
}
